import React from "react";
import { IoCloseSharp } from "react-icons/io5";

const PrivacyPolicyModal = ({ isOpen, onClose }) => {
    if (isOpen !== "privacy") return null;
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-primary-500/50 backdrop-blur-sm px-2 sm:px-4">
            <div className="relative bg-white w-full max-w-3xl rounded-2xl shadow-2xl overflow-hidden">
                {/* Header */}
                <div className="flex items-center justify-between bg-primary-600 rounded-t-lg py-3 px-5">
                    <h2 className="font-semibold text-lg sm:text-xl text-primary-100">
                        SAN LMS Privacy Policy
                    </h2>
                    <button
                        onClick={onClose}
                        className="rounded-full p-1 text-gray-200  cursor-pointer"
                    >
                        <IoCloseSharp size={20} />
                    </button>
                </div>

                {/* Content */}
                <div className="p-5 max-h-[80vh] overflow-y-auto text-gray-800">
                    <p className="text-sm text-gray-500 mb-4">
                        <strong className="text-primary-600">Effective Date:</strong> March 14, 2026
                    </p>
                    <p className="text-sm text-gray-700 mb-4">
                        SAN LMS, operated by SAN Technovation Pvt. Ltd. (&quot;we,&quot; &quot;us,&quot; or &quot;our&quot;), is committed to
                        protecting your privacy. This Privacy Policy describes how we collect, use, and safeguard
                        your personal information when you use our platform.
                    </p>

                    {/* Section 1 */}
                    <h3 className="font-semibold text-blue-700 mt-4 mb-2">1. Information We Collect</h3>
                    <p className="mt-4 mb-2 font-semibold">To provide a seamless learning experience, we collect the following categories of
                        information:</p>
                    <ul className="list-disc list-inside text-sm text-gray-700 space-y-1">
                        <li>
                            Personal Identity Data: Name, email address, phone number, and account login
                            credentials.
                        </li>
                        <li>
                            Learning Metrics: Course enrollments, progress tracking, quiz scores, and lesson
                            completion timestamps.
                        </li>
                        <li>Technical Log Data: IP address, device type, browser version, and access logs to
                            ensure platform stability and security.</li>
                    </ul>
                    {/* Section 2 */}
                    <h3 className="font-semibold text-blue-700 mt-4 mb-2">
                        2. How We Use Your Data
                    </h3>
                    <p className="text-sm">
                        Your information is strictly used to facilitate and improve your educational journey:
                    </p>

                    <ul className="list-disc list-inside text-sm text-gray-700 space-y-1">
                        <li>
                            Service Delivery: Granting access to purchased content and managing your profile.
                        </li>
                        <li>
                            Progress Tracking: Providing you and your instructors with accurate learning
                            analytics.
                        </li>
                        <li>Communication: Sending essential course updates, certificates of completion, and
                            technical support responses.</li>
                        <li>Platform Integrity: Detecting and preventing unauthorized access or intellectual
                            property theft.</li>
                    </ul>

                    {/* Section 3 */}
                    <h3 className="font-semibold text-blue-700 mt-4 mb-2">
                        3. Data Security &amp; Protection
                    </h3>
                    <p className="text-sm">
                        We implement industry-standard security protocols to keep your data safe, including:
                    </p>

                    <ul className="list-disc list-inside text-sm text-gray-700 space-y-1">
                        <li>
                            Encrypted Authentication: Secure login processes to prevent account hijacking.
                        </li>
                        <li>
                            Access Control: Limiting internal data access only to authorized personnel who
                            require it for platform maintenance.
                        </li>
                        <li>Regular Monitoring: Continuous oversight of system performance to identify
                            potential vulnerabilities.</li>
                    </ul>
                    <p className="text-sm">
                        Note: While we strive to use commercially acceptable means to protect your
                        Personal Information, remember that no method of transmission over the
                        internet is 100% secure.
                    </p>



                    {/* Section 4 */}
                    <h3 className="font-semibold text-blue-700 mt-4 mb-2">
                        4. Third-Party Sharing
                    </h3>
                    <p className="text-sm">
                        We do not sell, trade, or rent your personal information to third parties. Sharing only occurs
                        under the following circumstances:
                    </p>

                    <ul className="list-disc list-inside text-sm text-gray-700 space-y-1">
                        <li>
                            Service Providers: Trusted partners (like cloud hosting or payment gateways) who
                            assist in operating our platform, provided they agree to keep this information
                            confidential.
                        </li>
                        <li>
                            Legal Compliance: When required by law, subpoena, or government regulation.
                        </li>
                    </ul>

                    {/* Section 5 */}
                    <h3 className="font-semibold text-blue-700 mt-4 mb-2">5. User Responsibilities &amp; Conduct</h3>
                    <p className="text-sm">
                        As a user of SAN LMS, you agree to:
                    </p>
                    <ul className="list-disc list-inside text-sm text-gray-700 space-y-1">
                        <li>
                            Maintain the confidentiality of your login credentials.
                        </li>
                        <li>
                            Use the platform exclusively for personal learning purposes.
                        </li>
                        <li>
                            Refrain from distributing, recording, or sharing course materials without explicit
                            written permission from SAN Technovation.
                        </li>
                        <li>
                            Refrain from distributing, recording, or sharing course materials without explicit
                            written permission from SAN Technovation.
                        </li>
                    </ul>

                    {/* Section 6 */}
                    <h3 className="font-semibold text-blue-700 mt-4 mb-2">
                        6. Data Retention &amp; Deletion
                    </h3>
                    <p className="text-sm">
                        We retain your information for as long as your account is active or as needed to provide you
                        with your learning history. If you wish to close your account or request data deletion, please
                        contact us using the details below.
                    </p>

                    {/* Section 7 */}
                    <h3 className="font-semibold text-blue-700 mt-4 mb-2">
                        7. Grievance Officer &amp; Contact Information
                    </h3>
                    <p>In accordance with the Information Technology Act and rules made there under, the contact
                        details of the Grievance Officer are provided below:</p>
                    <p className="text-sm">SAN Technovation Pvt. Ltd. 2nd Floor, VSM Complex, Near Anna Silai, Kanjikovil Road,
                        Perundurai - 638052, Tamil Nadu, India.</p>
                    <p className="text-sm">
                        Phone: +91 74181 69679 Email: [Insert Support/Privacy Email Here]
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicyModal;
